// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609160704/js/" + chunkId + "." + {"44":"65ccdf0a","225":"1c15f922","481":"41a39ddf","486":"fdf6d601","770":"f403455c"}[chunkId] + ".0.07606578016556942.chunk.js";
};